import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Spacing24 } from 'autogen/design-tokens/tokens';
import { ScrollToTopArrowLabel } from 'autogen/translation-keys/trans-website-shared';
import Icon from 'components/Icon';
import useScrollEffect from 'hooks/globals/useScrollEffect';
import { zIndex } from 'variables';
import useIsProductListIntersecting from '../shared/hooks/useIsProductListIntersecting';
import useProductListTopPosition from '../shared/hooks/useProductListPositionTopPosition';
import useScrollToTopOfProductList from '../shared/hooks/useScrollToTopOfProductList';

const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 60px;
    background-color: #222222;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    z-index: ${zIndex.fixed - 500};
    bottom: ${Spacing24};
    box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.15);
`;

export default function ProductListShortcutArrow() {
    const { t } = useTranslation();
    const scrollToTopOfProductList = useScrollToTopOfProductList();
    const productListTopPosition = useProductListTopPosition();
    const [shouldDisplay, setShouldDisplay] = useState(false);
    const productListShowArrowBuffer = 424;

    useScrollEffect(({ scrollTop, direction }) => {
        if (scrollTop > productListTopPosition + productListShowArrowBuffer && direction === 'up') {
            setShouldDisplay(true);
        } else {
            setShouldDisplay(false);
        }
    });

    const isProductListIntersecting = useIsProductListIntersecting();

    if (!shouldDisplay || !isProductListIntersecting) return null;

    return (
        <Button onClick={scrollToTopOfProductList} aria-label={t(ScrollToTopArrowLabel)}>
            <Icon type="ArrowUp" size={24} fill="white" />
        </Button>
    );
}
